export default __webpack_public_path__ + "static/media/husata.f26fab33.jpg";